import React from 'react';
import { Create, SimpleForm, TextInput, Toolbar } from 'react-admin';
import { Funeral } from '../types';
import { ContractBaseEdit } from './ContractBaseEdit';
import { ContractSaveButton } from './ContractSaveButton';
import { Divider, Typography } from '@mui/material';

const validateLinesExist = (values:any) => {
  const errors: {[k: string]: any} = {};
  if(values.lines === undefined || values.lines.length === 0){
    errors.lines = 'You must have at least one item';
  }

  return errors;

}

export const ContractCreate = () => {
  return (
    <Create>
      <SimpleForm
        toolbar={
          <Toolbar>
            <ContractSaveButton />
          </Toolbar>
        }
        validate={validateLinesExist}
      >
        <ContractBaseEdit />
      </SimpleForm>
    </Create>
  );
};
